var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const TaskStatuses = {
    notStarted: { id: 1, label: "Not Started" },
    inProgress: { id: 2, label: "In Progress" },
    completed: { id: 3, label: "Completed" },
    cancelled: { id: 4, label: "Cancelled" },
};
export const TaskPriorities = {
    low: { id: 1, label: "Low" },
    medium: { id: 2, label: "Medium" },
    high: { id: 3, label: "High" },
};
export function stringToDate(string) {
    return new Date(string);
}
export const getTaskFromDto = (dto) => {
    const { createdDate, modifiedDate, assignedDate, statusModifiedDate } = dto, task = __rest(dto, ["createdDate", "modifiedDate", "assignedDate", "statusModifiedDate"]);
    if (!task.associatedPeople) {
        task.associatedPeople = [];
    }
    if (!task.resources) {
        task.resources = [];
    }
    task.createdDate = stringToDate(createdDate);
    task.modifiedDate = stringToDate(modifiedDate);
    task.assignedDate = stringToDate(assignedDate);
    task.statusModifiedDate = stringToDate(statusModifiedDate);
    // Cast through any to get flow to trust this conversion.
    return task;
};
